module.exports = __webpack_public_path__ + "static/media/55_000079.c4c14d50.jpg";